import { Entity, MicroMClient } from "@mcurros2/microm";
import { ProductosIcon } from "../../Productos/Productos";
import { ClientesProductosImportacionDef } from "./ClientesProductosImportacionDef";

export const ClientesProductosImportacionIcon = ProductosIcon;
export const ClientesProductosImportacionHelpText = '* <Your help text>.';

export class ClientesProductosImportacion extends Entity<ClientesProductosImportacionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesProductosImportacionDef(), parentKeys);
        this.Form = import('./ClientesProductosImportacionForm').then((module) => module.ClientesProductosImportacionForm);
        this.Title = "Clientes Productos Importacion";
        this.HelpText = ClientesProductosImportacionHelpText;
        this.Icon = ClientesProductosImportacionIcon;
    }
}